import { Injectable } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export enum LegacyEventsEnum {
  // sign in messages
  UserSignIn = 'sendUserSignInMessage',
  UserSignOut = 'sendUserSignOutMessage',

  // sign in dialogs
  ShowSignInDialog = 'popUnderSignInModal',
  ShowSignOutDialog = 'popUnderSignOutModal',
  ShowSignUpDialog = 'popUnderSignUpModal',

  // profile messages
  ShowUpdateProfileDialogSuccess = 'popUnderUpdateProfileModal_CompleteProfile',
  ProfileUpdated = 'sendUserProfileUpdated',
  ProfileDeleted = 'sendUserProfileDeleted',

  // profile dialog
  ShowUserMyAccountDialog = 'popUnderUserMyAccountModal',
  ShowUpdateProfileDialog = 'popUnderUpdateProfileModal',

  // user account types messages
  UserIsActiveEnterprise = 'sendUserIsActiveEnterpriseMessage',
  UserIsActiveProfessional = 'sendUserIsActiveProfessionalMessage',
  UserIsNotEnterprise = 'sendUserIsNotEnterpriseMessage',
  UserIsNotProfessional = 'sendUserIsNotProfessionalMessage',
  UserIsPastDueEnterprise = 'sendUserIsPastDueEnterpriseMessage',
  UserIsPastDueProfessional = 'sendUserIsPastDueProfessionalMessage',

  // upgrade dialogs
  ShowEnrollDialog = 'popUnderEnrollmentModal',

  // upgrade options
  ShowSettingsDialog = 'popUnderSettingsModal',
  ShowUpdateSubscriptionDialog = 'popUnderUpdateSubscriptionModal',
  ShowUpgradeDialog = 'popUnderUpgradeHumanModal',

  // checkout dialog
  ShowCheckoutDialog = 'popUnderSubscriptionModal',

  ShowEnterpriseDomainDialog = 'popUnderEnterpriseDomainModal',

  // dialog messages
  CloseDialogBoxMessage = 'sendUserClosesModalDialogBoxMessage',

  // developer app selection
  DeveloperAppSelected = 'sendDeveloperAppSelected',

  // misc
  ShowSelectDevAppDialog = 'popUnderSelectDevAppModal',
  ShowSocialShareDialog = 'popUnderSocialShareModal',
  ShowUserPremiumAlertDialog = 'popUnderUserPremiumAlertModal',
  ShowUserTourAlertDialog = 'popUnderUserTourAlertModal',
  ShowUserGenderToggleDialog = 'popUnderUserGenderToggleAlert',
  ShowUserTestAbortAlert = 'popUnderUserTestAbortAlert'
}

export class LegacyMessage {
  type: string;
  eventName: string;
  eventData: any;
}

@Injectable({
  providedIn: 'root'
})
export class LegacyMessageService {
  
  private messageSubject = new Subject<LegacyMessage>();

  constructor() {
    this.initMessageListner();
  }

  /**
   * Observe a legacy event
   */
  onEvent(event: LegacyEventsEnum) {
    return this.messageSubject.asObservable()
      .pipe(
        filter((e) => e.eventName === event)
      );
  }

  private initMessageListner() {
    const legacyTypeName = 'human.web.legacy';

    fromEvent(window, 'message')
      .pipe(
        // validate: filter out legacy messages
        filter((e: MessageEvent) => {
          const { origin, data } = e;
          return origin === window.location.origin
            && data
            && typeof (data) === 'string'
            && `${data}`.indexOf(legacyTypeName) !== -1;
        }),
        // extract data
        map((e: MessageEvent) => <LegacyMessage>JSON.parse(e.data)),
        // validate legacy message
        filter((e: LegacyMessage) => e && e.type === legacyTypeName)
      )
      .subscribe((message) => {
        this.messageSubject.next(message);
      });
  }
}
